const LAYOUT_MAIN_SELECTOR = '[data-testid="layout-authenticated"] main';

const MIN_VISIBLE_SIZE_PX = 8;

export function getLayoutMainElement(): HTMLElement | null {
  return document.querySelector<HTMLElement>(LAYOUT_MAIN_SELECTOR);
}

export function getLayoutMainBounds(): DOMRect | null {
  const main = getLayoutMainElement();
  if (!main) {
    return null;
  }
  return main.getBoundingClientRect();
}

export function intersectRects(a: DOMRect, b: DOMRect): DOMRect | null {
  const top = Math.max(a.top, b.top);
  const left = Math.max(a.left, b.left);
  const right = Math.min(a.right, b.right);
  const bottom = Math.min(a.bottom, b.bottom);

  if (right - left < MIN_VISIBLE_SIZE_PX || bottom - top < MIN_VISIBLE_SIZE_PX) {
    return null;
  }

  return new DOMRect(left, top, right - left, bottom - top);
}

export function clipRectToLayoutMain(rect: DOMRect): DOMRect | null {
  const mainBounds = getLayoutMainBounds();
  if (!mainBounds) {
    return rect;
  }
  return intersectRects(rect, mainBounds);
}

export function isInsideOnboardingModal(element: Element): boolean {
  return element.closest('[data-onboarding-modal]') !== null;
}

export function getOnboardingModalScrollContainer(element: Element): HTMLElement | null {
  return element.closest<HTMLElement>('[data-onboarding-modal-scroll]');
}

/** Recorta o retângulo do alvo à viewport visível do scroll do modal (evita spotlight na altura total da lista). */
export function clipRectToModalScrollViewport(element: Element, rect: DOMRect): DOMRect | null {
  const scrollContainer = getOnboardingModalScrollContainer(element);
  if (!scrollContainer) {
    return rect;
  }
  const scrollBounds = scrollContainer.getBoundingClientRect();
  return intersectRects(rect, scrollBounds);
}

export function readSpotlightRect(element: Element): DOMRect | null {
  const rect = element.getBoundingClientRect();
  if (isInsideOnboardingModal(element)) {
    return clipRectToModalScrollViewport(element, rect);
  }
  return clipRectToLayoutMain(rect);
}

export function readSpotlightClipBounds(element: Element | null): DOMRect | null {
  if (element && isInsideOnboardingModal(element)) {
    return null;
  }
  return getLayoutMainBounds();
}

export function boundsToClipPath(bounds: DOMRect): string {
  const top = Math.max(0, bounds.top);
  const left = Math.max(0, bounds.left);
  const right = Math.max(0, window.innerWidth - bounds.right);
  const bottom = Math.max(0, window.innerHeight - bounds.bottom);
  return `inset(${top}px ${right}px ${bottom}px ${left}px)`;
}
